import routerConstants from '@/constants/routerConstants'

export type EntityCodeType =
  | 'hoaDon'
  | 'traHang'
  | 'datHang'
  | 'phieuXuatKho'
  | 'phieuNhapKho'
  | 'chuyenHang'
  | 'kiemKe'
  | 'yeuCauSuaChua'
  | 'yeuCauXuatHoaDon'
  | 'datHangNcc'
  | 'phieuNhanHang'
  | 'khachHang'
  | 'product'

export type EntityCodeRef = {
  type: EntityCodeType
  id: string
  code?: string
}

export type EntityCodeOpenRequest = EntityCodeRef & {
  /** Gọi sau khi lưu ở modal sửa / thao tác trong chi tiết (vd. tải lại list đang đứng). */
  onChanged?: () => void
}

/** Ctrl/⌘ + click hoặc chuột giữa mở trang list ở tab mới — list tự mở modal qua `?editId=` / hàng hóa `?detailId=` (modal chi tiết). */
export const entityCodeHref = (type: EntityCodeType, id: string): string => {
  const editId = `?editId=${encodeURIComponent(id)}`
  const detailId = `?detailId=${encodeURIComponent(id)}`
  switch (type) {
    case 'yeuCauXuatHoaDon':
      return routerConstants.yeuCauXuatHoaDon.detail.replace(':id', encodeURIComponent(id))
    case 'product':
      return `${routerConstants.product.list}${detailId}`
    default:
      return `${routerConstants[type].list}${editId}`
  }
}
